import React from 'react';

const BudgetMarginRow = ({ line, isGrossMargin, sectionCode }) => {
  const numVal = parseFloat(line.budget_amount) || 0;
  const isPositive = numVal > 0;
  const isNegative = numVal < 0;

  const formatAmount = (val) => {
    if (val == null || val === '') return '0.00';
    return parseFloat(val).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatPercent = (val) => {
    if (val == null || val === '') return '0.00';
    return parseFloat(val).toFixed(2);
  };

  const signClass = isNegative ? 'margin-negative' : isPositive ? 'margin-positive' : 'margin-zero';
  const rowClass = [
    'budget-margin-row',
    isGrossMargin ? 'gross-margin-row' : 'net-margin-row',
    signClass,
  ].filter(Boolean).join(' ');

  const signLabel = isNegative ? 'Loss' : isPositive ? 'Profit' : null;

  return (
    <tr className={rowClass}>
      <td className="margin-label-cell">
        <span className="margin-label-text">{line.line_label}</span>
        {signLabel && (
          <span className={`margin-floating-badge ${isNegative ? 'badge-loss' : 'badge-profit'}`}>
            {signLabel}
          </span>
        )}
      </td>
      {sectionCode === 'BELOW_GROSS_ADJUSTMENTS' && <td></td>}
      <td></td>
      <td></td>
      <td className="amount-cell">
        <span className="margin-value">{formatAmount(line.amount_per_unit)}</span>
      </td>
      <td className="percent-cell">
        <span className="margin-value">{formatPercent(line.percent_of_revenue)}%</span>
      </td>
      <td className="amount-cell">
        <span className="margin-value margin-total">{formatAmount(line.budget_amount)}</span>
      </td>
      <td></td>
    </tr>
  );
};

export default BudgetMarginRow;
